export class RegistrationConfirmationStatusViewModel {
  public static readonly SUCCESSFUL = 'Successful';
  public static readonly INVALID = 'Invalid';
  public static readonly ALREADY_CONFIRMED = 'AlreadyConfirmed';
  public static readonly EXPIRED = 'Expired';
  public static readonly CONFIRMED_EMAIL_UPDATE = 'ConfirmedEmailUpdate';
}
